module.exports = __webpack_public_path__ + "img/permaswap-logo.bed9e9d2.png";